class BoAuthService {
    async loginWithPassword(email, password) {
        const response = await fetch('/api/v2/backoffice/login', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password }),
        });

        return this.#parseResponse(response);
    }

    async postGoogleCode(code) {
        const response = await fetch('/api/v2/backoffice/auth/google', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code }),
        });

        return this.#parseResponse(response);
    }

    async postGoogleCredential(credential) {
        const response = await fetch('/api/v2/backoffice/auth/google/token', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ credential }),
        });

        return this.#parseResponse(response);
    }

    async requestPasswordReset(email) {
        const response = await fetch('/api/v2/backoffice/password/reset-request', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email }),
        });

        return this.#parseResponse(response);
    }

    async confirmPasswordReset(token, password) {
        const response = await fetch('/api/v2/backoffice/password/reset-confirm', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token, password }),
        });

        return this.#parseResponse(response);
    }

    /**
     * Logs the user out: the firewall's logout listener invalidates the session and clears the
     * cookie. The response is a redirect (not JSON), so it is intentionally not parsed.
     */
    async logout() {
        await fetch('/api/v2/backoffice/auth/logout', {
            method: 'POST',
            credentials: 'same-origin',
        });
    }

    async #parseResponse(response) {
        let jsonResponse;
        try {
            jsonResponse = await response.json();
        } catch {
            jsonResponse = {};
        }

        if (!response.ok) {
            const error = new Error(`HTTP ${response.status}`);
            error.response = jsonResponse;
            error.status = response.status;
            throw error;
        }

        return jsonResponse;
    }
}

export default BoAuthService;
